import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import BookingSummary from "../components/BookingSummary";
import { advancereserveLocker, bulkLockerReserver, getTenantAndAssignmentSettings } from "../api/api";
import { generateReserveTiming, getPathForNextPage, handleBulkReservationPayment } from "../lib/Utils";
import { LOCAL_STORAGE, LS_LOCKER_BANK_INFO, USER_INFO } from "../assets/constants/BrowserStorageKeys";
import { getSecureItemFromSpecificStorage } from "../lib/BrowserStorageAccessMiddleware";
import { BOOKING_SUMMARY, LOCKER_SIZE_SELECTION, LOGIN } from "../assets/constants/PageList";
import { TOAST_SUCCESS } from "../assets/constants/Constants";
import ShowToast from "../components/ToastComponent";

const BookingSummaryPage = () => {
  const history = useHistory();
  const state = history.location?.state || {};
  const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
  const [is_state_gst , setIsStateGst] = React.useState(false);


  const {
    selectedLockers = [],
    address = "puna lulla nagar",
    lockerCurrency = "INR",
    bookingTimingObject = [],
    lockerBankId = null,
    assignmentSlug = null,
    locker_bank_slug = null,
    IsAdvanceBooking = false,
  } = state;

  const resolvedCurrency =
    lockerCurrency && lockerCurrency !== "null"
      ? lockerCurrency
      : selectedLockers?.[0]?.currency || "INR";

useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await getTenantAndAssignmentSettings(lockerBankInfo?.id);
        if(response?.status === "success"){
          setIsStateGst(response?.data?.locker_bank?.is_state_gst);
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
  
   fetchSettings();
  }, []);
      

  const handleEditSelection = () => {
    history.replace({
      pathname: getPathForNextPage(BOOKING_SUMMARY, LOCKER_SIZE_SELECTION),
      state: {
        ...state,
        selectedLockers,
      },
    });
  };

  const handleLockerBooking = async (lockers = null, total = null, finalGSTObject ) => {
    const finalLockers = lockers || selectedLockers;
    const finalTotal = total ?? 0;

    let allocationData = [];

    if (finalLockers[0]?.selectedSlot && finalLockers[0]?.bookingSlots) {
      allocationData = finalLockers.map((locker) => ({
        door_size: locker.door_size,
        price: Number(locker?.selectedSlot?.price || 0),
        slot_id: locker?.selectedSlot?.id || null,
      }));
    } else {
      allocationData = finalLockers.map((locker) => ({
        door_size: locker.door_size,
        price: Number(locker.price || 0),
        slot_id: locker.slot_id || null,
      }));
    }


    if (IsAdvanceBooking) {
    const bookingObject = {
      ...bookingTimingObject,
      allocation_method: "automatic_allocation",
      allocation_data: allocationData,
      total_price: finalTotal,
      locker_bank_id: lockerBankId,
      locker_bank_slug: locker_bank_slug
        ? locker_bank_slug
        : getSecureItemFromSpecificStorage(LOCAL_STORAGE, "locker_slug"),
      assignmentSlug: assignmentSlug,
    };
const userData = await getSecureItemFromSpecificStorage(
                        LOCAL_STORAGE,
                        USER_INFO
                        );
        console.log('usrData:', userData)
      if(userData){
            // reserve api call then payment 
            // show the loader before calling reserve api and payment 
           try {
                 // set loader true
                  const reserveLockerResponse = await advancereserveLocker(bookingObject);
                  console.log("responsedata :", reserveLockerResponse);
                  if (reserveLockerResponse?.data?.status === "success") {
                      ShowToast("Locker reserved successfully! Please wait for payment processing.", TOAST_SUCCESS);
                      await handleBulkReservationPayment(reserveLockerResponse, history,finalGSTObject, { isAdvanceBooking: true });
                  }
            } catch (error) {
              // show toast message for error show 
                 console.log("error happend during advance bokking", error)
            } finally {
                // set loader false
            }

        }
        else{
      history.push({
        pathname: getPathForNextPage(BOOKING_SUMMARY, LOGIN),
        state: {
          bookingObject: bookingObject,
          finalGSTObject
        },
      });
    }
    } else {
      const bookingObject = {
      allocation_method: "automatic_allocation",
      allocation_data: allocationData,
      total_price: finalTotal,
      locker_bank_id: lockerBankId,
      locker_bank_slug: locker_bank_slug
        ? locker_bank_slug
        : getSecureItemFromSpecificStorage(LOCAL_STORAGE, "locker_slug"),
      assignmentSlug: assignmentSlug,
    };
      const reserveLockerResponse = await bulkLockerReserver(bookingObject);
      await handleBulkReservationPayment(reserveLockerResponse, history, finalGSTObject, {
        isAdvanceBooking: IsAdvanceBooking,
      });
    }
  };

  return (
    <div className="booking-summary-page">
      <div className="locker-summary-container">
        <BookingSummary
          lockerCurrency={resolvedCurrency}
          bookingLockerHandler={handleEditSelection}
          selectedLockers={selectedLockers}
          address={address}
          handleLockerBooking={handleLockerBooking}
          is_state_gst={is_state_gst}
        />
      </div>
    </div>
  );
};

export default BookingSummaryPage;
